<div class="widget">
    <label>{{DayFilterLabel}}</label>
    <div class="input-group">
        <div fxFlex.gt-sm="50" id="leave-filter-days-from">
            <mat-form-field class="half-width-form-field">
                <mat-label>Desde</mat-label>
                <input type="number" matInput [formControl]="DaysFrom" (keyup)="triggerDayChange('From')"
                    autocomplete="off">
            </mat-form-field>

            <mat-error *ngIf="DaysFrom.invalid && DaysFrom.touched" class="error-space">
                <span *ngIf="DaysFrom.hasError('min')">Es menor que 0</span>
                <span *ngIf="DaysFrom.hasError('max')">Es más de 545</span>
            </mat-error>
        </div>
        <div fxFlex.gt-sm="50" id="leave-filter-days-to">
            <mat-form-field class="half-width-form-field">
                <mat-label>Hasta</mat-label>
                <input type="number" matInput [formControl]="DaysTo" (keyup)="triggerDayChange('To')"
                    autocomplete="off">
            </mat-form-field>
            <mat-error *ngIf="DaysTo.invalid && DaysTo.touched" class="error-space">
                <span *ngIf="DaysTo.hasError('min')">Es menor que 0</span>
                <span *ngIf="DaysTo.hasError('max')">Es más de 545</span>
            </mat-error>
        </div>
        <div id="leave-filter-days-options" *ngIf="IsDropdownVisible">
            <button class="menu-dropdown menu-btn" mat-button [matMenuTriggerFor]="DayOptions"><span
                    class="mat-select-arrow">
                    <mat-icon role="img" class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" 
                    aria-hidden="true" data-mat-icon-type="font">arrow_drop_down</mat-icon>
                </span></button>
            <mat-menu #DayOptions="matMenu" class="full-width">
                <button mat-menu-item *ngFor="let option of dayOptions$"
                    (click)="setSelectedOption(option)">{{option.text}}</button>
            </mat-menu>
        </div>
    </div>
</div>